import { render, staticRenderFns } from "./AudioPreview.vue?vue&type=template&id=7484f468&"
import script from "./AudioPreview.vue?vue&type=script&lang=ts&"
export * from "./AudioPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports